import axios from "@/libs/api.request";
// 获取列表
export const getBranchShipment = data => {
  return axios.request({
    url: "/finance/branch/outbound",
    method: "post",
    data
  });
};
// 分公司明细重新计算
export const recalculate = data => {
  return axios.request({
    url: "/finance/branch/outbound/recalculate",
    method: "post",
    data
  });
};

// 分公司明细生成账单
export const createBill = data => {
  return axios.request({
    url: "/finance/branch/outbound/createBill",
    method: "post",
    data
  });
};

// 批量取消挂起
export const cancelHang = data => {
  return axios.request({
    url: "/finance/branch/outbound/cancelAbnormal",
    method: "post",
    data
  });
};
